import React from 'react';
import DashboardContainer from '../customDashboards/dashboardContainer';
import { PRECONFIGURED_TYPES } from '../customDashboards/widgetDataTypes';
import { ORGANIC_INSIGHTS_FILTERS, ORGANIC_INSIGHTS_DEFAULT_FILTERS } from './filters';

export default function Page() {
    return (
        <DashboardContainer
            preconfiguredType={PRECONFIGURED_TYPES.ORGANIC_INSIGHTS}
            topFilters={ORGANIC_INSIGHTS_FILTERS}
            defaultTopFilters={ORGANIC_INSIGHTS_DEFAULT_FILTERS}
        />
    );
}
